import React from "react";
import { useNavigate } from "react-router-dom";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useCustomerAddresses } from "../hooks";

interface IProps {
  customerId: number;
}

export const CustomerAddressesList: React.FC<IProps> = ({ customerId }) => {
  const navigate = useNavigate();
  const { data, loading } = useCustomerAddresses({ where: { customerId } });

  if (loading) return <Loading />;

  if (!data?.customerAddresses?.results?.length) {
    return <EmptyList text="Aucune adresse" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Type</TableCell>
          <TableCell header>Libellé</TableCell>
          <TableCell header>Ville</TableCell>
          <TableCell header align="center">
            Active
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.customerAddresses?.results?.map((address) => (
          <TableRow
            key={`customer-address-${address.id}`}
            onClick={() => navigate(`/customer-address/${address.id}`)}
          >
            <TableCell>{address.type}</TableCell>
            <TableCell>{address.label}</TableCell>
            <TableCell>{address.city}</TableCell>
            <TableCell align="center">{address.active ? "Oui" : "Non"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
